import React from 'react';
import { Link } from 'react-router-dom';
import usePageTitle from '../../hooks/usePageTitle';
import './LegalPage.css';

export default function FacebookDataDeletion() {
  usePageTitle('Facebook Data Deletion');

  return (
    <main className="legalPage">
      <div className="legalPage__card">
        <span className="legalPage__eyebrow">TingVision</span>
        <h1>Facebook data deletion instructions</h1>
        <p className="legalPage__updated">Last updated: 5 August 2026</p>

        <p>
          TingVision stores the Facebook Page name, Page ID, Page image, granted permissions, and access credentials needed to connect the Page you choose. Disconnecting removes the saved Facebook credentials and Page connection from TingVision.
        </p>

        <h2>Remove the connection in TingVision</h2>
        <ol>
          <li>Sign in to your TingVision account.</li>
          <li>Open <strong>Settings</strong>.</li>
          <li>Find <strong>Facebook Page</strong> and select <strong>Disconnect</strong>.</li>
          <li>Confirm the request. The saved Page connection and access credentials are deleted immediately.</li>
        </ol>

        <h2>Remove TingVision in Facebook</h2>
        <p>
          You can also remove TingVision from Facebook&apos;s Apps and Websites settings. This stops any further access from the Facebook side. If you use this option, you may also disconnect in TingVision to remove the locally saved connection immediately.
        </p>

        <h2>Ask us to delete it for you</h2>
        <p>
          Email <a href="mailto:nadav.ossendryver@gmail.com">nadav.ossendryver@gmail.com</a> from the address associated with your TingVision account and ask us to delete your Facebook connection data. We may need to verify that the account belongs to you.
        </p>

        <div className="legalPage__links">
          <Link to="/settings">Open TingVision settings</Link>
          <Link to="/privacy-policy">Read the Privacy Policy</Link>
        </div>
      </div>
    </main>
  );
}
